@if (value()) {
  <app-branches-form
    [edit]="true"
    [create]="false"
    [delete]="false"
    [details]="false"
    [value]="value()"
    [access]="access()"
  ></app-branches-form>
}

